//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IMailingDTO } from '../../../DTO/IMailingDTO';

//element.Name=MailingController result.Name=MailingController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.MailingController);
/** WebApiController: MailingController */
export class MailingController extends DefaultDtoControllerProxy<IMailingDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'Mailings', BusinessObjectType.Mailing);
	}
	public SpoolingStatus(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Mailings/SpoolingStatus?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IMailingDTO>
	{
		return (this.axios.get('Mailings/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
